import React from 'react';
import { BookOpen, Map, Database, Users, Calendar, Target, ClipboardList, Brain, MessageSquare, Activity } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatsIncluded() {
  const features = [{
    icon: <BookOpen className="w-8 h-8 text-amber" data-id="element-244" />,
    title: 'Complete Coaching Philosophy',
    desc: 'Age-specific coaching frameworks, player development principles, and session management systems that give you a professional foundation.',
    metric: 'Core Framework'
  }, {
    icon: <Map className="w-8 h-8 text-amber" data-id="element-245" />,
    title: 'Age Development Roadmaps',
    desc: 'Complete development pathways for every age group: U4, U5, U6, U7, U8, U9, U10, U11, U12, U13. Know exactly what to focus on at every stage.',
    metric: '10 Age Groups'
  }, {
    icon: <Database className="w-8 h-8 text-amber" data-id="element-246" />,
    title: 'Massive Drill Libraries',
    desc: '100 Ball Mastery, 100 Dribbling, 100 Passing, 75 First Touch, 100 Shooting, 75 Defending. Every drill includes: diagram, coaching points, progressions, and setup.',
    metric: '550+ Drills'
  }, {
    icon: <Users className="w-8 h-8 text-amber" data-id="element-247" />,
    title: 'Small-Sided Games Vault',
    desc: '150 small-sided games (1v1 through 7v7) to develop decision-making and game intelligence.',
    metric: '150 Games'
  }, {
    icon: <Activity className="w-8 h-8 text-amber" data-id="element-248" />,
    title: 'Fully Planned Training Sessions',
    desc: 'Complete session plans for every age group (U4–U13), each including warm-up, technical activity, skill development, game activity, match play, and cool down.',
    metric: '200 Sessions'
  }, {
    icon: <Calendar className="w-8 h-8 text-amber" data-id="element-249" />,
    title: '40-Week Season Planning System',
    desc: 'A complete annual roadmap so you always know what to coach, when, and why.',
    metric: '40 Weeks'
  }, {
    icon: <Target className="w-8 h-8 text-amber" data-id="element-250" />,
    title: 'Player Development & Assessment',
    desc: 'Player evaluations, progress tracking, goal setting, and assessment templates.',
    metric: 'Assessment System'
  }, {
    icon: <ClipboardList className="w-8 h-8 text-amber" data-id="element-251" />,
    title: 'Coach Administration Toolkit',
    desc: 'Attendance sheets, team rosters, match day forms, and season trackers.',
    metric: 'Admin Toolkit'
  }, {
    icon: <Brain className="w-8 h-8 text-amber" data-id="element-252" />,
    title: 'Sports Psychology Section',
    desc: 'Practical frameworks for building confidence, motivation, leadership, and positive team culture.',
    metric: 'Psychology Guide'
  }, {
    icon: <MessageSquare className="w-8 h-8 text-amber" data-id="element-253" />,
    title: 'Parent Communication System',
    desc: 'Parent meeting templates, communication scripts, and parent management strategies so you spend less time dealing with difficult situations.',
    metric: 'Comms Scripts'
  }];
  return <section className="bg-forest py-24 px-4" data-id="element-254">
      <div className="max-w-6xl mx-auto" data-id="element-255">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-16 uppercase" data-id="element-256">
          Here's Everything Inside{' '}
          <span className="text-brightGreen" data-id="element-257">Soccer Ready™</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-258">
          {features.map((feature, index) => <div key={index} className="bg-ink rounded-xl p-6 border border-white/5 hover:border-amber/30 transition-colors flex gap-6" data-id="element-259">
              <div className="shrink-0 bg-forest p-3 rounded-lg border border-white/10 h-fit" data-id="element-260">
                {feature.icon}
              </div>
              <div className="min-w-0" data-id="element-261">
                <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 mb-2" data-id="element-262">
                  <h3 className="font-bold text-white text-lg" data-id="element-263">
                    {feature.title}
                  </h3>
                  <span className="self-start text-xs font-bold uppercase tracking-wider text-amber bg-amber/10 px-2 py-1 rounded whitespace-nowrap" data-id="element-264">
                    {feature.metric}
                  </span>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-265">
                  {feature.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-266">
          <CTAButton text="Get The Complete System Now →" data-id="element-267" />
        </div>
      </div>
    </section>;
}